import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../home/components/Footer';
import AdobePDFHero from './components/AdobePDFHero';
import PlatformSupport from './components/PlatformSupport';
import LanguageSupport from './components/LanguageSupport';
import CoreFeatures from './components/CoreFeatures';
import TrustedBy from './components/TrustedBy';
import Testimonials from './components/Testimonials';
import RelatedArticles from './components/RelatedArticles';
import Newsletter from './components/Newsletter';

export default function AdobePDFLibraryPage() {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://documogul.com';
    
    document.title = 'Adobe PDF Library SDK - 专业PDF开发工具包 | 星允信息';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Adobe PDF Library SDK是业界领先的PDF处理开发工具包，支持C++、.NET、Java等多种开发语言，可跨平台集成到Windows、macOS、Linux系统。提供完整的PDF创建、编辑、转换、安全加密等功能。');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'Adobe PDF Library,PDF SDK,PDF开发工具,PDF API,跨平台PDF,C++ PDF,Java PDF,.NET PDF,PDF处理库');
    }

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `${siteUrl}/adobe-pdf-library`);

    const structuredData = {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      "name": "Adobe PDF Library SDK",
      "applicationCategory": "DeveloperApplication",
      "operatingSystem": "Windows, macOS, Linux",
      "description": "Adobe PDF Library SDK是业界领先的PDF处理开发工具包，支持C++、.NET、Java等多种开发语言",
      "url": `${siteUrl}/adobe-pdf-library`,
      "offers": {
        "@type": "Offer",
        "availability": "https://schema.org/InStock",
        "priceCurrency": "CNY",
        "price": "按需定制"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.9",
        "reviewCount": "87"
      },
      "provider": {
        "@type": "Organization",
        "name": "星允信息科技有限公司"
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <AdobePDFHero />
        <PlatformSupport />
        <LanguageSupport />
        <CoreFeatures />
        <TrustedBy />
        <Testimonials />
        <RelatedArticles />
        <Newsletter />
      </main>
      <Footer />
    </div>
  );
}
